import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook, Youtube } from "lucide-react";

export function Footer() {
  return (
    <footer className="bg-card/50 border-t border-border/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <div className="mb-4 flex items-center gap-3">
              <div className="h-10 w-1 bg-accent" aria-hidden="true" />
              <div>
                <h3 className="text-base font-heading font-bold text-foreground tracking-tight">
                  Proton Health Labs
                </h3>
                <p className="text-primary text-xs font-medium uppercase">Be a Proton™ — Always Positive</p>
              </div>
            </div>
            <p className="text-muted-foreground text-sm leading-relaxed mb-4">
              Transparently dosed, fully disclosed formulas. Made in the USA. Always positive.
            </p>
            <div className="flex gap-3">
              <a 
                href="https://www.instagram.com/protonhealthlabs" 
                target="_blank" 
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-muted/50 hover:bg-primary/10 hover:text-primary text-muted-foreground transition-all"
                aria-label="Follow us on Instagram"
              >
                <Instagram className="h-4 w-4" />
              </a>
              <a 
                href="https://www.facebook.com/protonhealthlabs" 
                target="_blank" 
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-muted/50 hover:bg-primary/10 hover:text-primary text-muted-foreground transition-all"
                aria-label="Follow us on Facebook"
              >
                <Facebook className="h-4 w-4" />
              </a>
              <a 
                href="https://www.youtube.com/@protonhealthlabs" 
                target="_blank" 
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-muted/50 hover:bg-primary/10 hover:text-primary text-muted-foreground transition-all"
                aria-label="Subscribe on YouTube"
              >
                <Youtube className="h-4 w-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-foreground uppercase tracking-wider mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-muted-foreground hover:text-primary text-sm transition-colors">Home</Link></li>
              <li><Link to="/products/brain-charge" className="text-muted-foreground hover:text-primary text-sm transition-colors">Brain Charge</Link></li>
              <li><Link to="/about" className="text-muted-foreground hover:text-primary text-sm transition-colors">Our Story</Link></li>
              <li><Link to="/contact" className="text-muted-foreground hover:text-primary text-sm transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-foreground uppercase tracking-wider mb-4">Contact</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-muted-foreground text-sm">
                <Phone className="h-4 w-4 text-primary/70" />
                <span>(732) 513-8942</span>
              </li>
              <li className="flex items-center gap-2 text-muted-foreground text-sm">
                <Mail className="h-4 w-4 text-primary/70" />
                <span>orders@protonhealthlabs.com</span>
              </li>
              <li className="flex items-start gap-2 text-muted-foreground text-sm">
                <MapPin className="h-4 w-4 text-primary/70 mt-0.5" />
                <span>Boca Raton, FL</span>
              </li>
            </ul>
          </div>
        </div>

        <p className="mt-8 text-[11px] sm:text-xs leading-relaxed text-muted-foreground max-w-3xl">
          *These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease.
        </p>

        <div className="border-t border-border/50 mt-6 pt-6 flex flex-col sm:flex-row justify-between items-center gap-4">
          <div className="text-center sm:text-left">
            <p className="text-muted-foreground text-xs">
              © {new Date().getFullYear()} Proton Health Labs™. All rights reserved.
            </p>
            <p className="text-xs font-medium text-foreground mt-1">
              Proudly MADE IN THE U.S.A. by a U.S. Marine 🇺🇸
            </p>
          </div>
          <div className="flex flex-wrap gap-x-4 gap-y-1 justify-center sm:justify-end text-xs">
            <Link to="/privacy" className="text-muted-foreground hover:text-primary transition-colors">Privacy</Link>
            <Link to="/terms" className="text-muted-foreground hover:text-primary transition-colors">Terms</Link>
            <Link to="/shipping-returns" className="text-muted-foreground hover:text-primary transition-colors">Shipping &amp; Returns</Link>
            <Link to="/refund-policy" className="text-muted-foreground hover:text-primary transition-colors">Refunds</Link>
            <button
              type="button"
              onClick={() => window.dispatchEvent(new Event("phl:open-consent"))}
              className="text-muted-foreground hover:text-primary transition-colors"
            >
              Cookie preferences
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}